export default {
  SET_SELECTED_SERVICE(state, service) {
    state.selectedService = service;
  },
  SET_BOX_CALCULATE_BY(state, boxCalculateBy) {
    state.boxCalculateBy = boxCalculateBy;
  },
  SET_BOX_WEIGHT(state, boxWeight) {
    state.boxWeight = boxWeight;
  },
  SET_BOX_VOLUME(state, boxVolume) {
    state.boxVolume = boxVolume;
  },
  SET_TOTAL_PALLETS(state, totalPallets) {
    state.totalPallets = totalPallets;
  },
  SET_LOOSE_OPTION(state, looseOption) {
    state.looseOption = looseOption;
  },
  SET_MATERIAL_DIMENTIONS(state, materialDimentions) {
    state.materialDimentions = materialDimentions;
  },
  SET_TRANSPORT_OPTION(state, transportOption) {
    state.transportOption = transportOption;
  },
  RESET_ALL(state) {
    state.selectedService = null;
    state.boxCalculateBy = null;
    state.boxWeight = null;
    state.boxVolume = {
      height: null,
      width: null,
      length: null,
      boxesAmount: null,
      totalVolume: null,
    };
    state.totalPallets = null;
    state.looseOption = null;
    state.materialDimentions = {
      length: null,
      weight: null,
    };
    state.transportOption = null;
  },
};